import React from 'react';
import { inject, observer } from 'mobx-react';
import {Checkbox} from 'antd';
import { toJS } from 'mobx';
import { addContentPath } from '../../../util/pathUtil';
import {WeaInputLocale, WeaLocaleProvider} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
const getCurrentLabel = WeaInputLocale.getCurrentLabel;
const getMultiStrFromBase64 = WeaInputLocale.getMultiStrFromBase64;
@inject('portalLoginStore')
@observer
class AgreementInfo extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { portalLoginStore,formCloud } = this.props;
        const { labelObj, state, getElementStyle,onRememberChange } = portalLoginStore;
        const {
            isLogging,
            loginSettingInfo = {},
            loginFormItems,
            openAgreement,
            fixedContent,
            fixedContent_base64,
            agreementName,
            agreementName_base64,
            agreementLink,
            isCheckAgreement,
            langId,
            isDefaultAgreement
        } = state;
        let _loginFormItems = toJS(loginFormItems);
        let loginLength = _loginFormItems.length;
        let { loginButton, loginForm = {},agreementInfo } = loginSettingInfo;

        let fixedStyle,contentStyle;
        if(agreementInfo){
            fixedStyle={
                //fontFamily: agreementInfo.fontFamily,
                fontFamily: agreementInfo.fixedFontFamily,
                color: agreementInfo.fixedColor,
                //fontSize: agreementInfo.fixedFontSize,
                fontSize: agreementInfo.fontSize,
                fontWeight: agreementInfo.fixedFontWeight,
                fontStyle: agreementInfo.fixedFontStyle,
            };
            contentStyle={
                //fontFamily: agreementInfo.fontFamily,
                fontFamily: agreementInfo.contentFontFamily,
                color: agreementInfo.contentColor,
                // fontSize: agreementInfo.contentFontSize,
                fontSize: agreementInfo.fontSize,
                fontWeight: agreementInfo.contentFontWeight,
                fontStyle: agreementInfo.contentFontStyle,
            };
        }

        let topstyle = '';
        let _top = '';
        let _marginTop = 0;
        if (agreementInfo.isloginbtn == false) {
            topstyle = `calc(${agreementInfo.rate_y * 100}% + 256px)`;
        } else {
            topstyle = `${agreementInfo.rate_y * 100}% `;
        }
        if(formCloud=='E9'){
            let sub = parseInt($('.e9login-content .e9login-btn').css('top')) - parseInt($('.e9login-content .e9login-form-box').css('top'));
            let forgeth = $('.e9login-form-remember').height();
            if (parseInt(sub) > 208 && parseInt(sub) < 238) {
                if (loginLength < 3) {
                    if (forgeth > 20) {
                        _top = 20;
                    } else {
                        _top = 0;
                    }
                } else if (forgeth > 20) {
                    _top = (loginLength - 2) * 65 + 20;
                } else {
                    _top = (loginLength - 2) * 30;
                }
            } else if (loginLength < 3) {
                _top = 0;
            } else {
                _top = (loginLength - 2) * 30;
            }
        }else if(formCloud=='E8'){
            if(isDefaultAgreement==true){
                if (loginLength < 3) {
                    _top = 0;
                    // _marginTop=-65;
                } else  {
                    _top = 0;
                }
            }

        }else if(formCloud=='E7'){
            if (loginLength < 3) {
                _top = 0;
                _marginTop=0;
            } else  {
                _top = 0 ;
            }
        }else{
            _top = 0;

        }


        return (
            <div className="e9login-element e9login-form-agreementinfo" style={{ marginTop: `${_marginTop}px`,paddingTop: `${_top}px`, top: `${topstyle}`, ...getElementStyle(agreementInfo) }}>
                <div  className="e9login-agreementinfo">
                    <Checkbox checked={isCheckAgreement}  onChange={e => onRememberChange('agreement', e.target.checked)} ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@ilxktd`}>
                        <span className="e9login-form-fixedcontent" style={fixedStyle}>{getCurrentLabel(getMultiStrFromBase64(fixedContent_base64), langId) || fixedContent}</span>
                        <span className="e9login-form-agreement" style={contentStyle} onClick={event => this.onAgreementClick(agreementLink,event)}>{`《${getCurrentLabel(getMultiStrFromBase64(agreementName_base64), langId) || agreementName}》`}</span>
                    </Checkbox>
                </div>
            </div>
        );
    }
    onAgreementClick(link,e) {
        window.open(link);
        e && e.preventDefault();
    }
}

export default AgreementInfo;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e9login/AgreementInfo.js